import { createApp } from "vue";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import "element-plus/theme-chalk/dark/css-vars.css";
import ruLocale from "element-plus/dist/locale/ru.mjs";
import enLocale from "element-plus/dist/locale/en.mjs";
import App from "./App.vue";
import SvgIcon from "@/components/SvgIcon.vue";
import router from "./router";
import store from "./store";
import i18n from "./locales";
import "./main.css";
import "./styles/style.scss";
import "./styles/ai-style.scss";
import { useTheme } from "@/composables/useTheme";
useTheme();
const elLocales = {
  ru: ruLocale,
  en: enLocale,
  kk: ruLocale
};
const app = createApp(App);
import { Close, CloseBold, Search, Plus, ArrowDownBold, Check } from "@element-plus/icons-vue";
for (const [key, component] of Object.entries({
  Close,
  CloseBold,
  Search,
  Plus,
  ArrowDownBold,
  Check
})) {
  app.component(key, component);
}
router.beforeEach((to, from, next) => {
  const accessToken = localStorage.getItem("access_token");
  if (to.meta.requiresAuth && !accessToken) {
    next({
      name: "login"
    });
  } else {
    next();
  }
});
app.use(store).use(router).use(i18n).use(ElementPlus, {
  locale: elLocales[i18n.global.locale] || ruLocale
}).component("SvgIcon", SvgIcon).mount("#app");
const accessToken = localStorage.getItem("access_token");
if (accessToken) {
  store.dispatch("fetchProfile");
}